module.exports = __webpack_public_path__ + "img/80e11eb.jpg";